import React, { useState, useEffect } from 'react'
import moment from 'moment-jalaali'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Slide from '@material-ui/core/Slide'
import DialogTitle from '@material-ui/core/DialogTitle'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const item = { categoryId: '', brandId: '', itemId: '', quantity: 0 }

export default ({ touched, errors, setFieldValue, values, handleBlur }) => {
  const [detailsShow, setDetailsShow] = useState(false)
  const [detailsData, setDetailsData] = useState({})
  const [detailsInputs, setDetailsInputs] = useState([])

  const handleDetailsShow = model => {
    setDetailsData(model)
    setDetailsInputs(
      values.previousInputs?.filter(
        e => e.taskOperationId === model?.taskOperationId
      )
    )

    setDetailsShow(true)
  }

  return (
    <>
      <div className="row display-flex">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>ورق های پرس شده در شیفت های قبلی</legend>
            {values.previousOutputs?.length > 0 ? (
              <table
                className="table validator-table"
                style={{ marginBottom: 5 }}>
                <thead>
                  <tr>
                    <th className="text-center">ردیف</th>
                    <th className="text-center">دسته بندی</th>
                    <th className="text-center">برند</th>
                    <th className="text-center">نام کالا</th>
                    <th className="text-center">مقدار تولید شده</th>
                    <th className="text-center">شیفت</th>
                    <th className="text-center">مسئول شیفت</th>
                    <th className="text-center">تاریخ ثبت</th>
                  </tr>
                </thead>
                <tbody>
                  {values.previousOutputs?.map((item, index) => (
                    <tr
                      key={'p-' + index}
                      onClick={() => handleDetailsShow(item)}
                      className="pointer">
                      <td>{index + 1}</td>
                      <td>{item.product?.category.name}</td>
                      <td>{item.product?.brand.name}</td>
                      <td>{item.product?.name}</td>
                      <td>
                        {item.product !== undefined && (
                          <div className="flex-col flex-center">
                            <MeasurementTypeDoubleBox
                              product={item.product}
                              value={item.quantity}
                              onlySub
                            />
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        <div className="shift">{item.shift}</div>
                      </td>
                      <td>{item.user ? item.user.fullName : ''}</td>
                      <td>
                        {moment(item.createdAt, 'YYYY/M/D H:m').format(
                          'jYYYY/jM/jD ساعت H:mm'
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="text-center">موردی برای نمایش یافت نشد</p>
            )}
          </fieldset>
        </div>
      </div>

      <Dialog
        open={detailsShow}
        onClose={() => setDetailsShow(false)}
        TransitionComponent={Transition}
        scroll={'paper'}
        fullWidth={true}
        maxWidth="lg"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description">
        <DialogTitle>
          <Fab
            color="secondary"
            aria-label="refresh"
            size="small"
            onClick={() => setDetailsShow(false)}
            className="modal-close-btn">
            <MdClose size="20px" />
          </Fab>
          <span style={{ marginRight: 10 }} />
        </DialogTitle>
        <DialogContent dividers={true}>
          <DetailsForm data={detailsData} inputs={detailsInputs} />
        </DialogContent>
      </Dialog>
    </>
  )
}

const DetailsForm = props => {
  const [item, setItem] = useState(props.data)
  const [inputs, setInputs] = useState(props.inputs)

  useEffect(() => {
    setItem(props.data)
    console.log(props.data)
  }, [props.data])

  useEffect(() => {
    setInputs(props.inputs)
    console.log(props.inputs)
  }, [props.inputs])

  return (
    item && (
      <>
        <div className="row display-flex">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <fieldset className="fieldset">
              <legend>ورق های پرس شده</legend>
              <table
                className="table validator-table"
                style={{ marginBottom: 5 }}>
                <thead>
                  <tr>
                    <th className="text-center">ردیف</th>
                    <th className="text-center">دسته بندی</th>
                    <th className="text-center">برند</th>
                    <th className="text-center">نام کالا</th>
                    <th className="text-center">مقدار تولید شده</th>
                    <th className="text-center">مسئول شیفت</th>
                    <th className="text-center">تاریخ ثبت</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {values.previousOutputs && values.previousOutputs.map((item, index) => ( */}
                  <tr>
                    <td>{1}</td>
                    <td>{item.product?.category.name}</td>
                    <td>{item.product?.brand.name}</td>
                    <td>{item.product?.name}</td>
                    <td>
                      {item.product !== undefined && (
                        <div className="flex-col flex-center">
                          {item.product.subMeasurementType != undefined && (
                            <MeasurementTypeDoubleBox
                              product={item.product}
                              value={item.quantity}
                              onlySub
                            />
                          )}
                          {/* <span>
                          {(item.quantity + (item.product.measurementType !== undefined
                            ? ' (' + measurementTypes.filter(el => el.value === item.product.measurementType)[0].label + ')'
                            : ''))}
                        </span> */}
                        </div>
                      )}
                    </td>
                    <td>{item.user ? item.user.fullName : ''}</td>
                    <td>
                      {moment(item.createdAt, 'YYYY/M/D H:m').format(
                        'jYYYY/jM/jD ساعت H:mm'
                      )}
                    </td>
                  </tr>
                  {/* ))} */}
                </tbody>
              </table>
            </fieldset>
          </div>
        </div>

        <fieldset className="fieldset">
          <legend>مواد اولیه</legend>
          <table className="table validator-table" style={{ marginBottom: 5 }}>
            <thead>
              <tr>
                <th className="text-center">ردیف</th>
                <th className="text-center">دسته بندی</th>
                <th className="text-center">برند</th>
                <th className="text-center">نام کالا</th>
                <th className="text-center">کد کالا</th>
                <th className="text-center">مصرف اضافی</th>
                <th className="text-center">ضایعات</th>
              </tr>
            </thead>
            <tbody>
              {inputs?.map((item, index) => (
                <tr key={'p-' + index}>
                  <td>{index + 1}</td>
                  <td>{item.product?.category.name}</td>
                  <td>{item.product?.brand.name}</td>
                  <td>{item.product?.name}</td>
                  <td>{item.product?.extraCode}</td>
                  <td>
                    {item.product !== undefined && (
                      <div className="flex-col flex-center">
                        <MeasurementTypeDoubleBox
                          product={item.product}
                          value={item.extraQuantity}
                          onlySub={
                            item.subExtraQuantity !== undefined &&
                            item.extraQuantity !== item.subExtraQuantity
                              ? true
                              : false
                          }
                        />
                      </div>
                    )}
                  </td>
                  <td>
                    {item.product !== undefined && (
                      <div className="flex-col flex-center">
                        <MeasurementTypeDoubleBox
                          product={item.product}
                          value={item.waste}
                          onlySub={
                            item.subWaste !== undefined &&
                            item.waste !== item.subWaste
                              ? true
                              : false
                          }
                        />
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </fieldset>

        {item.taskOperation?.taskOperationInfos?.length > 0 && (
          <div className="row display-flex">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <fieldset className="fieldset">
                <legend>اطلاعات تکمیلی</legend>
                <table
                  className="table validator-table"
                  style={{ marginBottom: 5 }}>
                  <thead>
                    <tr>
                      {item.taskOperation?.taskOperationInfos?.map(
                        (item, index) => (
                          <th key={index} className="text-center">
                            {item.info?.name}
                          </th>
                        )
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {item.taskOperation?.taskOperationInfos?.map(
                        (item, index) => (
                          <th key={index} className="text-center">
                            {item.info?.fieldType === 0
                              ? item.value
                              : item.info?.fieldType === 2
                              ? yesNoFields.find(e => e.value === item.value)
                                  ?.text
                              : ''}
                          </th>
                        )
                      )}
                    </tr>
                  </tbody>
                </table>
              </fieldset>
            </div>
          </div>
        )}

        <div className="row display-flex">
          <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
            <fieldset className="fieldset">
              <legend>شیفت</legend>
              <div className="shift">{item.shift}</div>
            </fieldset>
          </div>
          <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
            <fieldset className="fieldset">
              <legend>توضیحات</legend>
              {item.description}
            </fieldset>
          </div>
        </div>
      </>
    )
  )
}

const yesNoFields = [
  { text: 'دارد', value: '1' },
  { text: 'ندارد', value: '2' }
]
